import {L10nConfig, L10nSchema} from 'angular-l10n';
import {mapKeys} from 'lodash-es';
import {LANG_HYPHEN_REG_BY_LOCALE, Locale} from '../../enums/language';
import {LOCALES} from './locales';

const SCHEMA_BY_LOCALE: Record<Locale, L10nSchema> = {
    [Locale.en_US]: {
        locale: {
            language: LANG_HYPHEN_REG_BY_LOCALE[Locale.en_US],
            currency: 'USD',
            timeZone: 'America/Los_Angeles',
            units:    {length: 'mile'},
        },
        dir:    'ltr',
        text:   'United States',
    },
    [Locale.es_ES]: {
        locale: {
            language: LANG_HYPHEN_REG_BY_LOCALE[Locale.es_ES],
            currency: 'EUR',
            timeZone: 'Europe/Madrid',
            units:    {'length': 'mile'}
        },
        dir:    'ltr',
        text:   'Spain'
    },
    [Locale.ru_RU]: {
        locale: {
            language: LANG_HYPHEN_REG_BY_LOCALE[Locale.ru_RU],
            currency: 'RUB',
            timeZone: 'Europe/Moscow',
            units:    {'length': 'kilometer'}
        },
        dir:    'ltr',
        text:   'Russia'
    }
};

/**
 * Ref.: https://github.com/robisim74/angular-l10n
 */
export const l10nConfig: L10nConfig = {
    format:         'language-region',
    providers:      [
        {
            name:  'app',
            asset: mapKeys(LOCALES, (localeStringsDict, localeId) =>
                LANG_HYPHEN_REG_BY_LOCALE[localeId as Locale])
        }
    ],
    fallback:       true,
    cache:          true,
    keySeparator:   '.',
    defaultLocale:  SCHEMA_BY_LOCALE.en_US.locale,
    schema:         [
        SCHEMA_BY_LOCALE.en_US,
        SCHEMA_BY_LOCALE.es_ES,
        SCHEMA_BY_LOCALE.ru_RU
    ],
    defaultRouting: true
};
